export default {
  methods: {
    getNewsletterTypes () {
      return this.$http.get(this.apiUrl('/newsletter_types', true)).then((resp) => {
        return this.processSuccess(resp).sort((a, b) => {
          if (a.name < b.name) {
            return -1
          } else if (a.name > b.name) {
            return 1
          }

          return 0
        })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/NewsletterTypesMixin.js